<script setup>
  import { ref } from 'vue'
  import FlyoutMenu from '@/components/Ui/FlyoutMenu.vue'

  const open = ref(false)

</script>

<template>
  <div>
    <button
      class="menu-toggle border-x border-white/30 px-6 h-full min-w-14 lg:min-w-20 min-h-12 flex w-auto flex-col relative items-center justify-center"
      aria-label="Hauptmenü öffnen"
      @click="open = !open"
    >
      <span
        class="block one h-[2px] absolute w-6 bg-white transition-transform"
        :class="open ? 'rotate-45 translate-y-0' : 'translate-y-2'"
      />
      <span
        class="block two h-[2px] absolute transition-opacity w-6 bg-white"
        :class="open ? 'opacity-0' : 'opacity-100'"
      />
      <span
        class="block three h-[2px] absolute w-6 bg-white transition-transform"
        :class="open ? '-rotate-45 translate-y-0' : '-translate-y-2'"
      />
    </button>
    <FlyoutMenu
      :open="open"
      @close="open = false"
    />
  </div>
</template>

<style lang="scss" scoped>
  button {
    span::after {
      content: '';
      @apply w-0 h-full absolute bottom-0 left-0 bg-primary transition-all duration-500;
    }
    &:hover {
      span::after {
        @apply w-full;
      }
    }
    .one {
      &::after {
        @apply delay-100;
      }
    }
    .two {
      &::after {
        @apply delay-500;
      }
    }
    .three {
      &::after {
        @apply delay-300;
      }
    }
  }

</style>
